"use client";

import { getSession } from "@/lib/auth";
import { useRouter } from "next/navigation";
import { useEffect } from "react";

export function SessionInitializer() {
  const router = useRouter();

  useEffect(() => {
    const session = getSession();

    if (session) {
      // Valid session exists - set cookie for middleware
      document.cookie = `admin_auth_token=${session.accessToken}; path=/; max-age=86400`;
    } else {
      // No valid session - clear any stale data and redirect to login if not already there
      document.cookie = "admin_auth_token=; path=/; max-age=0";
      localStorage.removeItem("admin_auth_token");
      localStorage.removeItem("admin_auth_user");
      localStorage.removeItem("admin_auth_expiry");

      // Only redirect if we're not on the auth page
      if (!window.location.pathname.startsWith("/auth/")) {
        router.push("/auth/sign-in");
      }
    }
  }, [router]);

  return null;
}
